<script setup lang="ts">
import { msal, loginRedirect } from '@/services/msal'
import { useI18n } from 'vue-i18n'
definePage({
  meta: {
    layout: 'public',
  },
  beforeEnter(_to, _from, next) {
    const accounts = msal.getAllAccounts()
    if (accounts.length > 0) {
      return next('/')
    }
    return next()
  },
})
const { query } = useRoute('/account/login')
const { t } = useI18n()
</script>

<template>
  <div class="flex flex-col items-center space-y-4">
    <Button
      color="green"
      @click="loginRedirect(query.redirect?.toString() ?? '/')"
    >
      {{ t('navigation.login') }}
    </Button>
    <RouterLink to="/new-user">
      <Button color="blue">{{ t('navigation.requestAccess') }}</Button>
    </RouterLink>
  </div>
</template>
